import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaUndo, FaMoneyCheckAlt } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { IoExitOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_HOST } from "../../api_utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

function MyStamp(props) {
  let navigate = useNavigate();
  const { userDataFromStorage, coloredTheme } = props;
  const [loading, setLoading] = useState(false);

  const [stampDutyReport, setStampDutyReport] = useState([]);
  const [owedLoanAfter, setOwedLoanAfter] = useState(null);
  const [owedLoanBefore, setOwedLoanBefore] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [nicknameList, setNicknameList] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [nickname, setNickname] = useState("");
  const [selectedCustomerNickname, setSelectedCustomerNickname] = useState("");
  const [nicknameForApi, setNicknameForApi] = useState("");
  const searchFilterOptionsShowNickname = useRef(true);
  const [commissionState, setCommissionState] = useState("owned");

  const getCnnyStartDateHandler = async () => {
    const { data } = await axios.get(
      `${API_HOST}/api/users/get_cnny_start_date_report`
    );
    if (data) {
      if (!data.message) {
        console.log("data::::", data);
        setOwedLoanAfter(
          new Date(data[0].cn_ny_start).toISOString().split("T")[0]
        );
      }
    }
  };

  const getAllCustomerList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer/get_customer_nickname_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      // setCustomerHeadList(data)
      setNicknameList(data);
    } else {
      setLoading(false);
    }
  };

  // getManagerAPI:
  const getStampReportList = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loan_header/stamp_duty?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (owedLoanBefore) {
      queryParams.push(`loan_before=${owedLoanBefore}`);
    }

    if (owedLoanAfter) {
      queryParams.push(`loan_after=${owedLoanAfter}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        console.log("data", data);
        let sortedData = data.sort((a, b) => a.loan_number - b.loan_number);
        setStampDutyReport(sortedData);
      }
    }
  };

  useEffect(() => {
    getCnnyStartDateHandler();
    getAllCustomerList();
  }, []);

  useEffect(() => {
    if (owedLoanAfter) {
      getStampReportList();
    }
  }, [owedLoanAfter]);

  // sum
  function sumFirstIndex(arr, nameToBeRendered) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i][`${nameToBeRendered}`];
    }
    return sum;
  }

  const handleCustomerNicknameChange = useCallback((e) => {
    setNickname(e.target.value);
  }, []);

  const filteredNicknameOptions = useMemo(() => {
    if (nickname && !selectedCustomerNickname) {
      console.log("here");
      const searchTerm = nickname.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      nicknameList.forEach((option) => {
        if (
          option.nickname &&
          option.nickname.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.nickname.toLowerCase().startsWith(searchTerm)",
            option.nickname.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.nickname.localeCompare(b.nickname, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedCustomerNickname) {
        console.log("here agent1111");
        setNicknameForApi(selectedCustomerNickname);
        setSelectedCustomerNickname("");

        searchFilterOptionsShowNickname.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowNickname.current = true;
      }

      return [];
    }
  }, [nickname, selectedCustomerNickname]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 md:text-[1.8rem] text-[1.3rem] tracking-wider">
        My Stamp Commission Report
      </p>
      <div className="bg-white  mt-[2%]">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem] ">
          Search Parameters
        </p>

        <div className="px-[0.5rem] mt-2">
          <div className="relative md:flex justify-start items-center mt-6">
            <p className="w-[30%]">Customer Nickname</p>
            <input
              type="text"
              value={nickname}
              placeholder="Enter Customer Nickname"
              onInput={(e) => {
                console.log("e.target::::::", e.target.value);
                handleCustomerNicknameChange(e);
              }}
              className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
            />
            {filteredNicknameOptions.length > 0 && (
              <div
                className={
                  searchFilterOptionsShowNickname.current
                    ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                    : "hidden"
                }>
                {filteredNicknameOptions.map((option, index) => (
                  <div
                    className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                    onClick={() => {
                      setSelectedCustomerNickname(option.nickname);
                      setNickname(option.nickname);
                    }}
                    key={index}>
                    {option.nickname}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="md:w-[25rem]">Commission</p>
            <div className="flex items-center">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={commissionState}
                  name="radio-buttons-group"
                  onChange={(e) => setCommissionState(e.target.value)}
                  row>
                  <FormControlLabel
                    value={"paid"}
                    control={<Radio />}
                    label="Paid"
                  />
                  <FormControlLabel
                    value={"owned"}
                    control={<Radio />}
                    label="Owned"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Loan Closed After </p>
            <input
              value={owedLoanAfter}
              onChange={(e) => setOwedLoanAfter(e.target.value)}
              type="date"
              disabled="true"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Loan Closed Before </p>
            <input
              value={owedLoanBefore}
              onChange={(e) => setOwedLoanBefore(e.target.value)}
              type="date"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
        </div>

        <div className="flex justify-start items-center space-x-4 p-[1rem]">
          <button
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <FiSearch />
            <p>Search</p>
          </button>
          <button
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <FaUndo />
            <p>Reset</p>
          </button>
        </div>
      </div>
      <div className="mt-8 overflow-scroll">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" md:w-[100%] w-[170%] p-[1rem] text-white">
          The total Stamp Commission reported is :{" "}
          {stampDutyReport.length
            ? `MYR ${sumFirstIndex(stampDutyReport, "stamp_commission")}`
            : "N/A"}
        </p>
        <table className="md:w-[100%] w-[170%]">
          <thead className="h-[6vh]">
            <tr className="border border-gray-700">
              <th className="text-center  px-[0.2rem] border-b border-r   border-gray-700 ">
                Loan Number
              </th>
              <th className="text-center  px-[0.2rem] border-b border-r   border-gray-700 ">
                Customer
              </th>
              <th className="text-center  px-[0.2rem] border-b border-r   border-gray-700 ">
                Loan Product
              </th>
              <th className="text-center  px-[0.2rem] border-b border-r   border-gray-700 ">
                Loan Closed
              </th>
              <th className="text-center  px-[0.2rem] border-b    border-gray-700 ">
                Stamp Commission
              </th>
              {/* <th className='text-center  px-[0.2rem] border-b    border-gray-700 '>Date Paid</th> */}
            </tr>
          </thead>
          <tbody>
            {commissionState === "owned" && stampDutyReport.length ? (
              stampDutyReport.map((x, index) => {
                let date = new Date(x.loan_closed);
                let formattedDate = date.toLocaleDateString("en-GB");
                return (
                  <tr
                    className={
                      index % 2 === 0
                        ? "bg-white border border-gray-700 "
                        : "border border-gray-700 bg-sky-100"
                    }
                    key={index}>
                    <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                      {x.loan_number}
                    </td>
                    <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                      {x.customer_nickname}
                    </td>
                    <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                      {x.loan_product}
                    </td>
                    <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                      {formattedDate}
                    </td>
                    <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                      MYR {x.stamp_commission}
                    </td>
                    {/* <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'> {formattedDate1}</td> */}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td>No Data Found !!!</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="mt-6 ">
          <button
            onClick={() => navigate("/home")}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default MyStamp;
